const gmatDataInsights = [

  // 1. DATA SUFFICIENCY

  // ── Medium ──
  {
    id: 201,
    section: "Data Insights",
    type: "dataSufficiency",
    topic: "Data Sufficiency",
    difficultyLevel: "Medium",
    difficultyScore: 560,
    discrimination: 1.2,
    timeLimit: 150,
    question: "What is the value of x?",
    statement1: "x + 5 = 12",
    statement2: "2x = 14",
    image: null,
    options: [
      "A. Statement (1) ALONE is sufficient, but statement (2) alone is not sufficient.",
      "B. Statement (2) ALONE is sufficient, but statement (1) alone is not sufficient.",
      "C. BOTH statements TOGETHER are sufficient, but neither statement alone is sufficient.",
      "D. EACH statement ALONE is sufficient.",
      "E. Statements (1) and (2) TOGETHER are still not sufficient."
    ],
    answer: "D"
  },

  // ── Easy ──
  {
    id: 206,
    section: "Data Insights",
    type: "dataSufficiency",
    topic: "Data Sufficiency",
    difficultyLevel: "Easy",
    difficultyScore: 400,
    discrimination: 0.85,
    timeLimit: 100,
    question: "What is the value of y?",
    statement1: "y - 4 = 10",
    statement2: "y = 14",
    image: null,
    options: [
      "A. Statement (1) ALONE is sufficient, but statement (2) alone is not sufficient.",
      "B. Statement (2) ALONE is sufficient, but statement (1) alone is not sufficient.",
      "C. BOTH statements TOGETHER are sufficient, but neither statement alone is sufficient.",
      "D. EACH statement ALONE is sufficient.",
      "E. Statements (1) and (2) TOGETHER are still not sufficient."
    ],
    answer: "D"
  },
  {
    id: 207,
    section: "Data Insights",
    type: "dataSufficiency",
    topic: "Data Sufficiency",
    difficultyLevel: "Easy",
    difficultyScore: 420,
    discrimination: 0.87,
    timeLimit: 105,
    question: "Is n an even number?",
    statement1: "n is divisible by 4",
    statement2: "n is divisible by 2",
    image: null,
    options: [
      "A. Statement (1) ALONE is sufficient, but statement (2) alone is not sufficient.",
      "B. Statement (2) ALONE is sufficient, but statement (1) alone is not sufficient.",
      "C. BOTH statements TOGETHER are sufficient, but neither statement alone is sufficient.",
      "D. EACH statement ALONE is sufficient.",
      "E. Statements (1) and (2) TOGETHER are still not sufficient."
    ],
    answer: "D"
  },
  {
    id: 208,
    section: "Data Insights",
    type: "dataSufficiency",
    topic: "Data Sufficiency",
    difficultyLevel: "Easy",
    difficultyScore: 440,
    discrimination: 0.88,
    timeLimit: 110,
    question: "What is the value of x?",
    statement1: "3x = 15",
    statement2: "x + 2 = 7",
    image: null,
    options: [
      "A. Statement (1) ALONE is sufficient, but statement (2) alone is not sufficient.",
      "B. Statement (2) ALONE is sufficient, but statement (1) alone is not sufficient.",
      "C. BOTH statements TOGETHER are sufficient, but neither statement alone is sufficient.",
      "D. EACH statement ALONE is sufficient.",
      "E. Statements (1) and (2) TOGETHER are still not sufficient."
    ],
    answer: "D"
  },
  {
    id: 209,
    section: "Data Insights",
    type: "dataSufficiency",
    topic: "Data Sufficiency",
    difficultyLevel: "Easy",
    difficultyScore: 465,
    discrimination: 0.9,
    timeLimit: 115,
    question: "Is x > 10?",
    statement1: "x = 12",
    statement2: "x > 5",
    image: null,
    options: [
      "A. Statement (1) ALONE is sufficient, but statement (2) alone is not sufficient.",
      "B. Statement (2) ALONE is sufficient, but statement (1) alone is not sufficient.",
      "C. BOTH statements TOGETHER are sufficient, but neither statement alone is sufficient.",
      "D. EACH statement ALONE is sufficient.",
      "E. Statements (1) and (2) TOGETHER are still not sufficient."
    ],
    answer: "A"
  },
  {
    id: 210,
    section: "Data Insights",
    type: "dataSufficiency",
    topic: "Data Sufficiency",
    difficultyLevel: "Easy",
    difficultyScore: 488,
    discrimination: 0.92,
    timeLimit: 118,
    question: "What is the perimeter of a square with side length s?",
    statement1: "s = 5",
    statement2: "The area of the square is 25",
    image: null,
    options: [
      "A. Statement (1) ALONE is sufficient, but statement (2) alone is not sufficient.",
      "B. Statement (2) ALONE is sufficient, but statement (1) alone is not sufficient.",
      "C. BOTH statements TOGETHER are sufficient, but neither statement alone is sufficient.",
      "D. EACH statement ALONE is sufficient.",
      "E. Statements (1) and (2) TOGETHER are still not sufficient."
    ],
    answer: "D"
  },

  // ── Medium ──
  {
    id: 211,
    section: "Data Insights",
    type: "dataSufficiency",
    topic: "Data Sufficiency",
    difficultyLevel: "Medium",
    difficultyScore: 505,
    discrimination: 1.1,
    timeLimit: 130,
    question: "What is the value of x?",
    statement1: "x² = 16",
    statement2: "x > 0",
    image: null,
    options: [
      "A. Statement (1) ALONE is sufficient, but statement (2) alone is not sufficient.",
      "B. Statement (2) ALONE is sufficient, but statement (1) alone is not sufficient.",
      "C. BOTH statements TOGETHER are sufficient, but neither statement alone is sufficient.",
      "D. EACH statement ALONE is sufficient.",
      "E. Statements (1) and (2) TOGETHER are still not sufficient."
    ],
    answer: "C"
  },
  {
    id: 212,
    section: "Data Insights",
    type: "dataSufficiency",
    topic: "Data Sufficiency",
    difficultyLevel: "Medium",
    difficultyScore: 535,
    discrimination: 1.15,
    timeLimit: 140,
    question: "Is x/y > 1?",
    statement1: "x > y",
    statement2: "y > 0",
    image: null,
    options: [
      "A. Statement (1) ALONE is sufficient, but statement (2) alone is not sufficient.",
      "B. Statement (2) ALONE is sufficient, but statement (1) alone is not sufficient.",
      "C. BOTH statements TOGETHER are sufficient, but neither statement alone is sufficient.",
      "D. EACH statement ALONE is sufficient.",
      "E. Statements (1) and (2) TOGETHER are still not sufficient."
    ],
    answer: "C"
  },
  {
    id: 213,
    section: "Data Insights",
    type: "dataSufficiency",
    topic: "Data Sufficiency",
    difficultyLevel: "Medium",
    difficultyScore: 565,
    discrimination: 1.18,
    timeLimit: 145,
    question: "What is the average of five consecutive integers?",
    statement1: "The smallest integer is 8",
    statement2: "The largest integer is 12",
    image: null,
    options: [
      "A. Statement (1) ALONE is sufficient, but statement (2) alone is not sufficient.",
      "B. Statement (2) ALONE is sufficient, but statement (1) alone is not sufficient.",
      "C. BOTH statements TOGETHER are sufficient, but neither statement alone is sufficient.",
      "D. EACH statement ALONE is sufficient.",
      "E. Statements (1) and (2) TOGETHER are still not sufficient."
    ],
    answer: "D"
  },
  {
    id: 214,
    section: "Data Insights",
    type: "dataSufficiency",
    topic: "Data Sufficiency",
    difficultyLevel: "Medium",
    difficultyScore: 600,
    discrimination: 1.2,
    timeLimit: 150,
    question: "Is quadrilateral ABCD a rectangle?",
    statement1: "All four angles of ABCD are right angles",
    statement2: "Opposite sides of ABCD are equal in length",
    image: null,
    options: [
      "A. Statement (1) ALONE is sufficient, but statement (2) alone is not sufficient.",
      "B. Statement (2) ALONE is sufficient, but statement (1) alone is not sufficient.",
      "C. BOTH statements TOGETHER are sufficient, but neither statement alone is sufficient.",
      "D. EACH statement ALONE is sufficient.",
      "E. Statements (1) and (2) TOGETHER are still not sufficient."
    ],
    answer: "A"
  },

  // ── Hard ──
  {
    id: 215,
    section: "Data Insights",
    type: "dataSufficiency",
    topic: "Data Sufficiency",
    difficultyLevel: "Hard",
    difficultyScore: 630,
    discrimination: 1.4,
    timeLimit: 160,
    question: "If x and y are integers, what is the value of x?",
    statement1: "xy = 12",
    statement2: "x and y are both positive, and x > y",
    image: null,
    options: [
      "A. Statement (1) ALONE is sufficient, but statement (2) alone is not sufficient.",
      "B. Statement (2) ALONE is sufficient, but statement (1) alone is not sufficient.",
      "C. BOTH statements TOGETHER are sufficient, but neither statement alone is sufficient.",
      "D. EACH statement ALONE is sufficient.",
      "E. Statements (1) and (2) TOGETHER are still not sufficient."
    ],
    answer: "E"
  },
  {
    id: 216,
    section: "Data Insights",
    type: "dataSufficiency",
    topic: "Data Sufficiency",
    difficultyLevel: "Hard",
    difficultyScore: 665,
    discrimination: 1.45,
    timeLimit: 165,
    question: "Is x² > x?",
    statement1: "x > 1",
    statement2: "x < 0",
    image: null,
    options: [
      "A. Statement (1) ALONE is sufficient, but statement (2) alone is not sufficient.",
      "B. Statement (2) ALONE is sufficient, but statement (1) alone is not sufficient.",
      "C. BOTH statements TOGETHER are sufficient, but neither statement alone is sufficient.",
      "D. EACH statement ALONE is sufficient.",
      "E. Statements (1) and (2) TOGETHER are still not sufficient."
    ],
    answer: "D"
  },
  {
    id: 217,
    section: "Data Insights",
    type: "dataSufficiency",
    topic: "Data Sufficiency",
    difficultyLevel: "Hard",
    difficultyScore: 700,
    discrimination: 1.48,
    timeLimit: 170,
    question: "A jar contains only red and blue marbles. If one marble is drawn at random, what is the probability that it is red?",
    statement1: "The jar contains 24 marbles in total",
    statement2: "The number of blue marbles is twice the number of red marbles",
    image: null,
    options: [
      "A. Statement (1) ALONE is sufficient, but statement (2) alone is not sufficient.",
      "B. Statement (2) ALONE is sufficient, but statement (1) alone is not sufficient.",
      "C. BOTH statements TOGETHER are sufficient, but neither statement alone is sufficient.",
      "D. EACH statement ALONE is sufficient.",
      "E. Statements (1) and (2) TOGETHER are still not sufficient."
    ],
    answer: "B"
  },
  {
    id: 218,
    section: "Data Insights",
    type: "dataSufficiency",
    topic: "Data Sufficiency",
    difficultyLevel: "Hard",
    difficultyScore: 725,
    discrimination: 1.52,
    timeLimit: 178,
    question: "What is the value of |x - 3|?",
    statement1: "x² - 6x + 9 = 0",
    statement2: "x < 5",
    image: null,
    options: [
      "A. Statement (1) ALONE is sufficient, but statement (2) alone is not sufficient.",
      "B. Statement (2) ALONE is sufficient, but statement (1) alone is not sufficient.",
      "C. BOTH statements TOGETHER are sufficient, but neither statement alone is sufficient.",
      "D. EACH statement ALONE is sufficient.",
      "E. Statements (1) and (2) TOGETHER are still not sufficient."
    ],
    answer: "A"
  },
  {
    id: 219,
    section: "Data Insights",
    type: "dataSufficiency",
    topic: "Data Sufficiency",
    difficultyLevel: "Hard",
    difficultyScore: 750,
    discrimination: 1.58,
    timeLimit: 185,
    question: "In a certain school, is the number of boys greater than the number of girls?",
    statement1: "The ratio of boys to girls is 5:4",
    statement2: "There are 180 students in total",
    image: null,
    options: [
      "A. Statement (1) ALONE is sufficient, but statement (2) alone is not sufficient.",
      "B. Statement (2) ALONE is sufficient, but statement (1) alone is not sufficient.",
      "C. BOTH statements TOGETHER are sufficient, but neither statement alone is sufficient.",
      "D. EACH statement ALONE is sufficient.",
      "E. Statements (1) and (2) TOGETHER are still not sufficient."
    ],
    answer: "A"
  },

  // 2. MULTI-SOURCE REASONING

  // ── Hard ──
  {
    id: 202,
    section: "Data Insights",
    type: "multiSourceReasoning",
    topic: "Multi-Source Reasoning",
    difficultyLevel: "Hard",
    difficultyScore: 700,
    discrimination: 1.3,
    timeLimit: 180,
    question: "Based on the two sources, which department had the highest expense growth from 2023 to 2024?",
    sources: [
      { title: "Memo", content: "The finance department reported a 12% increase in operating costs compared to last year, driven mainly by new compliance requirements." },
      { title: "Table: Department Expenses", content: "Marketing: 2023 ₹4L → 2024 ₹5.5L\nOperations: 2023 ₹6L → 2024 ₹6.5L" }
    ],
    image: null,
    options: ["A. Finance", "B. Marketing", "C. Operations", "D. Cannot be determined"],
    answer: "B"
  },

  // ── Easy ──
  {
    id: 220,
    section: "Data Insights",
    type: "multiSourceReasoning",
    topic: "Multi-Source Reasoning",
    difficultyLevel: "Easy",
    difficultyScore: 405,
    discrimination: 0.86,
    timeLimit: 120,
    question: "Based on the two sources, which employee type is affected by the new policy?",
    sources: [
      { title: "Email", content: "HR confirmed the new policy takes effect from August 1st, applying to all full-time employees." },
      { title: "Policy Summary Table", content: "Full-time: Applies — Yes\nPart-time: Applies — No\nIntern: Applies — No" }
    ],
    image: null,
    options: ["A. Full-time", "B. Part-time", "C. Intern", "D. All employee types"],
    answer: "A"
  },
  {
    id: 221,
    section: "Data Insights",
    type: "multiSourceReasoning",
    topic: "Multi-Source Reasoning",
    difficultyLevel: "Easy",
    difficultyScore: 425,
    discrimination: 0.87,
    timeLimit: 125,
    question: "Based on the two sources, what work is being done during Phase 2 of the renovation?",
    sources: [
      { title: "Notice", content: "The library will be closed for renovations from June 10 to June 20." },
      { title: "Renovation Schedule Table", content: "Phase 1 (June 10-15): Flooring\nPhase 2 (June 16-20): Lighting" }
    ],
    image: null,
    options: ["A. Flooring", "B. Lighting", "C. Painting", "D. Plumbing"],
    answer: "B"
  },
  {
    id: 222,
    section: "Data Insights",
    type: "multiSourceReasoning",
    topic: "Multi-Source Reasoning",
    difficultyLevel: "Easy",
    difficultyScore: 445,
    discrimination: 0.88,
    timeLimit: 128,
    question: "Based on the two sources, which intern submitted their timesheet late?",
    sources: [
      { title: "Memo", content: "All interns must submit their weekly timesheets by Friday 5 PM." },
      { title: "Timesheet Log", content: "Intern A: Submitted Friday 3 PM\nIntern B: Submitted Saturday 10 AM" }
    ],
    image: null,
    options: ["A. Intern A", "B. Intern B", "C. Both", "D. Neither"],
    answer: "B"
  },
  {
    id: 223,
    section: "Data Insights",
    type: "multiSourceReasoning",
    topic: "Multi-Source Reasoning",
    difficultyLevel: "Easy",
    difficultyScore: 465,
    discrimination: 0.9,
    timeLimit: 130,
    question: "Based on the two sources, on which day is the sports day more likely to proceed as planned?",
    sources: [
      { title: "Announcement", content: "The annual sports day will be held on the school playground, weather permitting." },
      { title: "Weather Forecast Table", content: "Saturday: Rain\nSunday: Clear" }
    ],
    image: null,
    options: ["A. Saturday", "B. Sunday", "C. Both equally", "D. Neither day"],
    answer: "B"
  },
  {
    id: 224,
    section: "Data Insights",
    type: "multiSourceReasoning",
    topic: "Multi-Source Reasoning",
    difficultyLevel: "Easy",
    difficultyScore: 488,
    discrimination: 0.92,
    timeLimit: 132,
    question: "Based on the two sources, which version introduced dark mode?",
    sources: [
      { title: "Product Update", content: "Version 2.0 of the app introduces dark mode and improved battery usage." },
      { title: "Changelog Table", content: "Version 1.5: Bug fixes\nVersion 2.0: Dark mode, battery improvements\nVersion 2.1: New icons" }
    ],
    image: null,
    options: ["A. Version 1.5", "B. Version 2.0", "C. Version 2.1", "D. Cannot be determined"],
    answer: "B"
  },

  // ── Medium ──
  {
    id: 225,
    section: "Data Insights",
    type: "multiSourceReasoning",
    topic: "Multi-Source Reasoning",
    difficultyLevel: "Medium",
    difficultyScore: 510,
    discrimination: 1.12,
    timeLimit: 155,
    question: "Based on the two sources, which store had the higher total revenue over the three months?",
    sources: [
      { title: "Report", content: "Store A's monthly revenue grew steadily over the past three months, while Store B's revenue fluctuated significantly." },
      { title: "Revenue Table", content: "Store A: Month 1 ₹2L, Month 2 ₹2.3L, Month 3 ₹2.6L\nStore B: Month 1 ₹3L, Month 2 ₹2L, Month 3 ₹3.5L" }
    ],
    image: null,
    options: ["A. Store A", "B. Store B", "C. Both equal", "D. Cannot be determined"],
    answer: "B"
  },
  {
    id: 226,
    section: "Data Insights",
    type: "multiSourceReasoning",
    topic: "Multi-Source Reasoning",
    difficultyLevel: "Medium",
    difficultyScore: 540,
    discrimination: 1.15,
    timeLimit: 160,
    question: "Based on the two sources, in which department was the satisfaction gap between remote and in-office employees the largest?",
    sources: [
      { title: "Survey Summary", content: "Employees who worked remotely reported higher satisfaction scores on average than those who worked in-office." },
      { title: "Satisfaction Table", content: "Remote: Dept X 8.2, Dept Y 7.9\nIn-office: Dept X 7.0, Dept Y 7.5" }
    ],
    image: null,
    options: ["A. Dept X", "B. Dept Y", "C. Both equal", "D. Cannot be determined"],
    answer: "A"
  },
  {
    id: 227,
    section: "Data Insights",
    type: "multiSourceReasoning",
    topic: "Multi-Source Reasoning",
    difficultyLevel: "Medium",
    difficultyScore: 575,
    discrimination: 1.18,
    timeLimit: 165,
    question: "Based on the two sources, which factory contributed to the increase in total production capacity?",
    sources: [
      { title: "Press Release", content: "The company's new factory investment increased total production capacity compared to last year." },
      { title: "Production Table", content: "Last year: Factory 1 — 500 units/day, Factory 2 — 300 units/day\nThis year: Factory 1 — 500 units/day, Factory 2 — 460 units/day" }
    ],
    image: null,
    options: ["A. Factory 1", "B. Factory 2", "C. Both equally", "D. Neither"],
    answer: "B"
  },
  {
    id: 228,
    section: "Data Insights",
    type: "multiSourceReasoning",
    topic: "Multi-Source Reasoning",
    difficultyLevel: "Medium",
    difficultyScore: 605,
    discrimination: 1.2,
    timeLimit: 170,
    question: "Based on the two sources, which traffic source shows the increase most consistent with the memo's claim?",
    sources: [
      { title: "Internal Memo", content: "The marketing team's new campaign led to a noticeable increase in website traffic, particularly from social media referrals." },
      { title: "Traffic Source Table", content: "Direct: Before 1000, After 1050\nSearch: Before 800, After 850\nSocial: Before 500, After 1200" }
    ],
    image: null,
    options: ["A. Direct", "B. Search", "C. Social", "D. All equally"],
    answer: "C"
  },

  // ── Hard ──
  {
    id: 229,
    section: "Data Insights",
    type: "multiSourceReasoning",
    topic: "Multi-Source Reasoning",
    difficultyLevel: "Hard",
    difficultyScore: 635,
    discrimination: 1.4,
    timeLimit: 180,
    question: "Based on the two sources, what is the most likely reason for the analyst's caution about future risk?",
    sources: [
      { title: "Analyst Note", content: "Company X's profit margin appears healthy at first glance, but a closer look at cost structure suggests future risk." },
      { title: "Financial Table", content: "Revenue: 2022 ₹50L, 2023 ₹60L\nCost of Goods Sold: 2022 ₹30L, 2023 ₹42L\nOperating Expenses: 2022 ₹8L, 2023 ₹9L" }
    ],
    image: null,
    options: [
      "A. Cost of goods sold grew at a faster rate than revenue, compressing gross margin despite higher sales.",
      "B. Operating expenses decreased.",
      "C. Revenue declined.",
      "D. The company had no costs in 2022."
    ],
    answer: "A"
  },
  {
    id: 230,
    section: "Data Insights",
    type: "multiSourceReasoning",
    topic: "Multi-Source Reasoning",
    difficultyLevel: "Hard",
    difficultyScore: 665,
    discrimination: 1.43,
    timeLimit: 185,
    question: "Based on the two sources, who bears responsibility for the loss of Shipment 1?",
    sources: [
      { title: "Legal Memo", content: "Under the proposed contract terms, Party A bears all risk of loss during shipping, while Party B assumes risk only after delivery is confirmed." },
      { title: "Shipment Log", content: "Shipment 1: Lost in transit\nShipment 2: Delivered and confirmed, then damaged in storage" }
    ],
    image: null,
    options: ["A. Party A", "B. Party B", "C. Both share responsibility equally", "D. Neither party"],
    answer: "A"
  },
  {
    id: 231,
    section: "Data Insights",
    type: "multiSourceReasoning",
    topic: "Multi-Source Reasoning",
    difficultyLevel: "Hard",
    difficultyScore: 695,
    discrimination: 1.46,
    timeLimit: 190,
    question: "Based on the two sources, in which age group was the difference in adverse event rates between treatment and placebo smallest?",
    sources: [
      { title: "Research Summary", content: "Trial results showed the treatment group had fewer adverse events than the placebo group, though the difference narrowed among older participants." },
      { title: "Adverse Event Table", content: "Age under 50: Treatment 5%, Placebo 12%\nAge 50 and older: Treatment 9%, Placebo 11%" }
    ],
    image: null,
    options: ["A. Under 50", "B. 50 and older", "C. Both equal", "D. Cannot be determined"],
    answer: "B"
  },
  {
    id: 232,
    section: "Data Insights",
    type: "multiSourceReasoning",
    topic: "Multi-Source Reasoning",
    difficultyLevel: "Hard",
    difficultyScore: 725,
    discrimination: 1.5,
    timeLimit: 195,
    question: "Based on the two sources, which cost category's projected change is most consistent with the memo's stated rationale for the merger's synergies?",
    sources: [
      { title: "Board Memo", content: "The proposed merger is expected to create cost synergies primarily through the elimination of duplicate administrative functions, rather than through changes to the sales force." },
      { title: "Post-Merger Cost Projection Table", content: "Administrative costs: Before ₹20L, Projected ₹12L\nSales costs: Before ₹15L, Projected ₹14.5L" }
    ],
    image: null,
    options: ["A. Administrative costs", "B. Sales costs", "C. Both equally", "D. Neither"],
    answer: "A"
  },
  {
    id: 233,
    section: "Data Insights",
    type: "multiSourceReasoning",
    topic: "Multi-Source Reasoning",
    difficultyLevel: "Medium",
    difficultyScore: 600,
    discrimination: 1.2,
    timeLimit: 165,
    question: "Based on the two sources, does the projected data support the report's claim about which district benefits most?",
    sources: [
      { title: "City Council Report", content: "The new transit line is projected to reduce average commute times most significantly for residents in the outer districts, who currently rely on infrequent bus service." },
      { title: "Commute Time Table", content: "Inner district: Current 25 min, Projected 22 min\nOuter district: Current 55 min, Projected 30 min" }
    ],
    image: null,
    options: [
      "A. Yes, the outer district shows a much larger projected reduction in commute time.",
      "B. No, the inner district shows a larger reduction.",
      "C. Both districts show identical reductions.",
      "D. The data is insufficient to determine any reduction."
    ],
    answer: "A"
  },


  // 3. TABLE ANALYSIS
  
  // ── Medium ──
  {
    id: 203,
    section: "Data Insights",
    type: "tableAnalysis",
    topic: "Table Analysis",
    difficultyLevel: "Medium",
    difficultyScore: 600,
    discrimination: 1.2,
    timeLimit: 150,
    statement: "More than half of the listed employees earn above ₹50,000.",
    table: {
      columns: ["Employee", "Department", "Salary (₹)"],
      rows: [["A", "Sales", "45000"], ["B", "Sales", "62000"], ["C", "IT", "71000"], ["D", "IT", "39000"]]
    },
    image: null,
    options: ["A. Yes", "B. No"],
    answer: "B"
  },

  // ── Easy ──
  {
    id: 234,
    section: "Data Insights",
    type: "tableAnalysis",
    topic: "Table Analysis",
    difficultyLevel: "Easy",
    difficultyScore: 400,
    discrimination: 0.85,
    timeLimit: 110,
    statement: "At least three of the listed students scored above 70 on the test.",
    table: {
      columns: ["Student", "Score"],
      rows: [["A", "65"], ["B", "82"], ["C", "74"], ["D", "90"], ["E", "60"]]
    },
    image: null,
    options: ["A. Yes", "B. No"],
    answer: "A"
  },
  {
    id: 235,
    section: "Data Insights",
    type: "tableAnalysis",
    topic: "Table Analysis",
    difficultyLevel: "Easy",
    difficultyScore: 420,
    discrimination: 0.87,
    timeLimit: 115,
    statement: "The total sales for January exceeded ₹100,000.",
    table: {
      columns: ["Product", "January Sales (₹)"],
      rows: [["Product A", "30000"], ["Product B", "45000"], ["Product C", "20000"]]
    },
    image: null,
    options: ["A. Yes", "B. No"],
    answer: "B"
  },
  {
    id: 236,
    section: "Data Insights",
    type: "tableAnalysis",
    topic: "Table Analysis",
    difficultyLevel: "Easy",
    difficultyScore: 440,
    discrimination: 0.88,
    timeLimit: 115,
    statement: "More employees work in the Sales department than in the IT department.",
    table: {
      columns: ["Employee", "Department"],
      rows: [["1", "Sales"], ["2", "IT"], ["3", "Sales"], ["4", "Sales"], ["5", "IT"], ["6", "HR"]]
    },
    image: null,
    options: ["A. Yes", "B. No"],
    answer: "A"
  },
  {
    id: 237,
    section: "Data Insights",
    type: "tableAnalysis",
    topic: "Table Analysis",
    difficultyLevel: "Easy",
    difficultyScore: 465,
    discrimination: 0.9,
    timeLimit: 118,
    statement: "The average age of the listed members is above 30.",
    table: {
      columns: ["Member", "Age"],
      rows: [["P", "25"], ["Q", "35"], ["R", "40"], ["S", "20"]]
    },
    image: null,
    options: ["A. Yes", "B. No"],
    answer: "B"
  },
  {
    id: 238,
    section: "Data Insights",
    type: "tableAnalysis",
    topic: "Table Analysis",
    difficultyLevel: "Easy",
    difficultyScore: 488,
    discrimination: 0.92,
    timeLimit: 120,
    statement: "Exactly two of the listed cities have a population above 1 million.",
    table: {
      columns: ["City", "Population (Millions)"],
      rows: [["City 1", "0.8"], ["City 2", "1.5"], ["City 3", "2.1"], ["City 4", "0.9"]]
    },
    image: null,
    options: ["A. Yes", "B. No"],
    answer: "A"
  },

  // ── Medium ──
  {
    id: 239,
    section: "Data Insights",
    type: "tableAnalysis",
    topic: "Table Analysis",
    difficultyLevel: "Medium",
    difficultyScore: 508,
    discrimination: 1.12,
    timeLimit: 140,
    statement: "The department with the highest average salary is IT.",
    table: {
      columns: ["Employee", "Department", "Salary (₹)"],
      rows: [["A", "Sales", "50000"], ["B", "Sales", "55000"], ["C", "IT", "70000"], ["D", "IT", "60000"], ["E", "HR", "45000"]]
    },
    image: null,
    options: ["A. Yes", "B. No"],
    answer: "A"
  },
  {
    id: 240,
    section: "Data Insights",
    type: "tableAnalysis",
    topic: "Table Analysis",
    difficultyLevel: "Medium",
    difficultyScore: 545,
    discrimination: 1.15,
    timeLimit: 145,
    statement: "The product with the lowest profit margin is Product C.",
    table: {
      columns: ["Product", "Revenue (₹)", "Cost (₹)"],
      rows: [["Product A", "10000", "6000"], ["Product B", "8000", "5000"], ["Product C", "12000", "9000"]]
    },
    image: null,
    options: ["A. Yes", "B. No"],
    answer: "A"
  },
  {
    id: 241,
    section: "Data Insights",
    type: "tableAnalysis",
    topic: "Table Analysis",
    difficultyLevel: "Medium",
    difficultyScore: 580,
    discrimination: 1.18,
    timeLimit: 148,
    statement: "The total number of units sold across all regions was less than 500.",
    table: {
      columns: ["Region", "Units Sold"],
      rows: [["North", "120"], ["South", "150"], ["East", "90"], ["West", "160"]]
    },
    image: null,
    options: ["A. Yes", "B. No"],
    answer: "B"
  },
  {
    id: 242,
    section: "Data Insights",
    type: "tableAnalysis",
    topic: "Table Analysis",
    difficultyLevel: "Medium",
    difficultyScore: 615,
    discrimination: 1.2,
    timeLimit: 150,
    statement: "More than half of the listed projects were completed on time.",
    table: {
      columns: ["Project", "Status"],
      rows: [["P1", "On Time"], ["P2", "Delayed"], ["P3", "On Time"], ["P4", "On Time"], ["P5", "Delayed"], ["P6", "Delayed"]]
    },
    image: null,
    options: ["A. Yes", "B. No"],
    answer: "B"
  },

  // ── Hard ──
  {
    id: 243,
    section: "Data Insights",
    type: "tableAnalysis",
    topic: "Table Analysis",
    difficultyLevel: "Hard",
    difficultyScore: 635,
    discrimination: 1.4,
    timeLimit: 165,
    statement: "The relationship between years of experience and salary is positive for every employee listed, without exception.",
    table: {
      columns: ["Employee", "Years of Experience", "Salary (₹)"],
      rows: [["A", "2", "40000"], ["B", "5", "55000"], ["C", "3", "60000"], ["D", "8", "70000"]]
    },
    image: null,
    options: ["A. Yes", "B. No"],
    answer: "B"
  },
  {
    id: 244,
    section: "Data Insights",
    type: "tableAnalysis",
    topic: "Table Analysis",
    difficultyLevel: "Hard",
    difficultyScore: 665,
    discrimination: 1.43,
    timeLimit: 170,
    statement: "Region East's sales grew at a faster percentage rate than Region West's from 2022 to 2023.",
    table: {
      columns: ["Region", "2022 Sales (₹L)", "2023 Sales (₹L)"],
      rows: [["East", "40", "52"], ["West", "60", "72"]]
    },
    image: null,
    options: ["A. Yes", "B. No"],
    answer: "A"
  },
  {
    id: 245,
    section: "Data Insights",
    type: "tableAnalysis",
    topic: "Table Analysis",
    difficultyLevel: "Hard",
    difficultyScore: 695,
    discrimination: 1.46,
    timeLimit: 175,
    statement: "The median salary among the listed employees is above ₹55,000.",
    table: {
      columns: ["Employee", "Salary (₹)"],
      rows: [["A", "40000"], ["B", "50000"], ["C", "58000"], ["D", "62000"], ["E", "45000"]]
    },
    image: null,
    options: ["A. Yes", "B. No"],
    answer: "B"
  },
  {
    id: 246,
    section: "Data Insights",
    type: "tableAnalysis",
    topic: "Table Analysis",
    difficultyLevel: "Hard",
    difficultyScore: 725,
    discrimination: 1.5,
    timeLimit: 178,
    statement: "Exactly one product category had a decrease in sales from Q1 to Q2.",
    table: {
      columns: ["Category", "Q1 Sales (₹L)", "Q2 Sales (₹L)"],
      rows: [["Electronics", "50", "55"], ["Clothing", "30", "28"], ["Furniture", "20", "20"], ["Toys", "15", "18"]]
    },
    image: null,
    options: ["A. Yes", "B. No"],
    answer: "A"
  },
  {
    id: 247,
    section: "Data Insights",
    type: "tableAnalysis",
    topic: "Table Analysis",
    difficultyLevel: "Hard",
    difficultyScore: 750,
    discrimination: 1.56,
    timeLimit: 185,
    statement: "Based on the spread of values shown, Group A's scores are more variable than Group B's.",
    table: {
      columns: ["Group", "Score 1", "Score 2", "Score 3", "Score 4"],
      rows: [["Group A", "40", "95", "60", "85"], ["Group B", "65", "70", "68", "72"]]
    },
    image: null,
    options: ["A. Yes", "B. No"],
    answer: "A"
  },


  // 4. GRAPHICS INTERPRETATION

  // ── Medium ──
  {
    id: 204,
    section: "Data Insights",
    type: "graphicsInterpretation",
    topic: "Graphics Interpretation",
    difficultyLevel: "Medium",
    difficultyScore: 610,
    discrimination: 1.2,
    timeLimit: 150,
    image: null,
    chart: {"type":"bar","title":"Quarterly Revenue ($K)","labels":["Q1","Q2","Q3","Q4"],"series":[{"name":"Revenue","values":[200,220,260,240]}],"unit":"$","yLabel":"Revenue ($K)"},
    blanks: [
      { text: "The quarter with the highest revenue was", options: ["Q1", "Q2", "Q3", "Q4"], answer: "Q3" },
      { text: "and revenue growth from Q1 to Q2 was approximately", options: ["5%", "10%", "15%", "20%"], answer: "10%" }
    ]
  },

  // ── Easy ──
  {
    id: 248,
    section: "Data Insights",
    type: "graphicsInterpretation",
    topic: "Graphics Interpretation",
    difficultyLevel: "Easy",
    difficultyScore: 405,
    discrimination: 0.86,
    timeLimit: 130,
    image: null,
    chart: {"type":"line","title":"Monthly Website Visitors","labels":["Jan","Feb","Mar","Apr","May","Jun"],"series":[{"name":"Visitors","values":[10000,11000,12500,13000,14200,15500]}],"yLabel":"Visitors"},
    blanks: [
      { text: "The month with the highest number of website visitors was", options: ["Mar", "Apr", "May", "Jun"], answer: "Jun" },
      { text: "and the percentage growth in visitors from Jan to Feb was approximately", options: ["5%", "10%", "15%", "20%"], answer: "10%" }
    ]
  },
  {
    id: 249,
    section: "Data Insights",
    type: "graphicsInterpretation",
    topic: "Graphics Interpretation",
    difficultyLevel: "Easy",
    difficultyScore: 425,
    discrimination: 0.88,
    timeLimit: 130,
    image: null,
    chart: {"type":"bar","title":"Sales by Region ($K)","labels":["North","South","East","West"],"series":[{"name":"Sales","values":[320,480,410,270]}],"unit":"$","yLabel":"Sales ($K)"},
    blanks: [
      { text: "The region with the highest sales was", options: ["North", "South", "East", "West"], answer: "South" },
      { text: "and the region with the second-highest sales was", options: ["North", "South", "East", "West"], answer: "East" }
    ]
  },
  {
    id: 250,
    section: "Data Insights",
    type: "graphicsInterpretation",
    topic: "Graphics Interpretation",
    difficultyLevel: "Easy",
    difficultyScore: 448,
    discrimination: 0.89,
    timeLimit: 132,
    image: null,
    chart: {"type":"pie","title":"Market Share by Company","labels":["Company A","Company B","Company C","Company D"],"series":[{"name":"Share","values":[40,25,20,15]}],"unit":"%"},
    blanks: [
      { text: "The company with the largest market share was", options: ["Company A", "Company B", "Company C", "Company D"], answer: "Company A" },
      { text: "and Company C's market share was approximately", options: ["15%", "20%", "25%", "40%"], answer: "20%" }
    ]
  },
  {
    id: 251,
    section: "Data Insights",
    type: "graphicsInterpretation",
    topic: "Graphics Interpretation",
    difficultyLevel: "Easy",
    difficultyScore: 468,
    discrimination: 0.9,
    timeLimit: 135,
    image: null,
    chart: {"type":"bar","title":"Weekly App Downloads","labels":["Week 1","Week 2","Week 3","Week 4"],"series":[{"name":"Downloads","values":[500,650,900,800]}],"yLabel":"Downloads"},
    blanks: [
      { text: "The week with the highest number of downloads was", options: ["Week 1", "Week 2", "Week 3", "Week 4"], answer: "Week 3" },
      { text: "and the number of downloads in Week 2 was approximately", options: ["500", "650", "700", "800"], answer: "650" }
    ]
  },
  {
    id: 252,
    section: "Data Insights",
    type: "graphicsInterpretation",
    topic: "Graphics Interpretation",
    difficultyLevel: "Easy",
    difficultyScore: 490,
    discrimination: 0.92,
    timeLimit: 138,
    image: null,
    chart: {"type":"bar","title":"City Population (millions)","labels":["City A","City B","City C","City D"],"series":[{"name":"Population","values":[1.2,3.5,2,4.6]}],"yLabel":"Millions"},
    blanks: [
      { text: "The city with the highest population was", options: ["City A", "City B", "City C", "City D"], answer: "City D" },
      { text: "and the population of City B was approximately", options: ["1.2 million", "2.0 million", "3.5 million", "4.0 million"], answer: "3.5 million" }
    ]
  },

  // ── Medium ──
  {
    id: 253,
    section: "Data Insights",
    type: "graphicsInterpretation",
    topic: "Graphics Interpretation",
    difficultyLevel: "Medium",
    difficultyScore: 515,
    discrimination: 1.12,
    timeLimit: 155,
    image: null,
    chart: {"type":"line","title":"Average Monthly Temperature (°C)","labels":["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],"series":[{"name":"Temp","values":[2,4,8,13,18,22,25,24,20,14,8,3]}],"unit":"°","yLabel":"°C"},
    blanks: [
      { text: "The warmest month shown was", options: ["Jan", "Mar", "Jul", "Nov"], answer: "Jul" },
      { text: "and the coldest month shown was", options: ["Jan", "Mar", "Sep", "Nov"], answer: "Jan" }
    ]
  },
  {
    id: 254,
    section: "Data Insights",
    type: "graphicsInterpretation",
    topic: "Graphics Interpretation",
    difficultyLevel: "Medium",
    difficultyScore: 550,
    discrimination: 1.15,
    timeLimit: 158,
    image: null,
    chart: {"type":"bar","title":"Product Returns by Category","labels":["Electronics","Clothing","Furniture","Toys"],"series":[{"name":"Returns","values":[140,180,80,100]}],"yLabel":"Returns"},
    blanks: [
      { text: "The category with the highest number of returns was", options: ["Electronics", "Clothing", "Furniture", "Toys"], answer: "Clothing" },
      { text: "and the approximate total returns across all categories shown was", options: ["400", "450", "500", "550"], answer: "500" }
    ]
  },
  {
    id: 255,
    section: "Data Insights",
    type: "graphicsInterpretation",
    topic: "Graphics Interpretation",
    difficultyLevel: "Medium",
    difficultyScore: 585,
    discrimination: 1.18,
    timeLimit: 160,
    image: null,
    chart: {"type":"line","title":"Employee Headcount","labels":["2020","2021","2022","2023","2024"],"series":[{"name":"Headcount","values":[150,160,170,200,230]}],"yLabel":"Employees"},
    blanks: [
      { text: "The year with the highest percentage growth in headcount compared to the previous year was", options: ["2021", "2022", "2023", "2024"], answer: "2023" },
      { text: "and the headcount in 2024 was approximately", options: ["200", "210", "230", "250"], answer: "230" }
    ]
  },
  {
    id: 256,
    section: "Data Insights",
    type: "graphicsInterpretation",
    topic: "Graphics Interpretation",
    difficultyLevel: "Medium",
    difficultyScore: 618,
    discrimination: 1.2,
    timeLimit: 162,
    image: null,
    chart: {"type":"line","title":"Monthly Conversion Rate (%)","labels":["Jan","Feb","Mar","Apr","May","Jun"],"series":[{"name":"Conversion","values":[2,2.2,2.3,2.5,2.7,3]}],"unit":"%","yLabel":"Conversion rate"},
    blanks: [
      { text: "The month with the highest conversion rate was", options: ["Mar", "Apr", "May", "Jun"], answer: "Jun" },
      { text: "and the approximate growth in conversion rate from Jan to Jun was", options: ["25%", "35%", "50%", "75%"], answer: "50%" }
    ]
  },

  // ── Hard ──
  {
    id: 257,
    section: "Data Insights",
    type: "graphicsInterpretation",
    topic: "Graphics Interpretation",
    difficultyLevel: "Hard",
    difficultyScore: 635,
    discrimination: 1.4,
    timeLimit: 180,
    image: null,
    chart: {"type":"line","title":"Annual Profit Margin (%)","labels":["2019","2020","2021","2022","2023"],"series":[{"name":"Margin","values":[12,9,11,15,13]}],"unit":"%","yLabel":"Profit margin"},
    blanks: [
      { text: "The year with the highest profit margin was", options: ["2019", "2020", "2022", "2023"], answer: "2022" },
      { text: "and the change in profit margin from 2019 to 2020 was approximately", options: ["-3 percentage points", "+2 percentage points", "-5 percentage points", "+3 percentage points"], answer: "-3 percentage points" }
    ]
  },
  {
    id: 258,
    section: "Data Insights",
    type: "graphicsInterpretation",
    topic: "Graphics Interpretation",
    difficultyLevel: "Hard",
    difficultyScore: 665,
    discrimination: 1.43,
    timeLimit: 185,
    image: null,
    chart: {"type":"bar","title":"Customer Satisfaction Score (out of 10)","labels":["Sales","Support","IT","HR"],"series":[{"name":"Score","values":[7.8,7.2,6.4,8.6]}],"yLabel":"Score"},
    blanks: [
      { text: "The department with the highest satisfaction score was", options: ["Sales", "Support", "IT", "HR"], answer: "HR" },
      { text: "and the department with the lowest satisfaction score was", options: ["Sales", "Support", "IT", "HR"], answer: "IT" }
    ]
  },
  {
    id: 259,
    section: "Data Insights",
    type: "graphicsInterpretation",
    topic: "Graphics Interpretation",
    difficultyLevel: "Hard",
    difficultyScore: 700,
    discrimination: 1.47,
    timeLimit: 190,
    image: null,
    chart: {"type":"groupedBar","title":"Ad Spend vs Sales by Quarter ($K)","labels":["Q1","Q2","Q3","Q4"],"series":[{"name":"Ad Spend","values":[50,80,70,60]},{"name":"Sales","values":[500,520,700,600]}],"unit":"$","yLabel":"$K"},
    blanks: [
      { text: "The quarter with the highest ad-spend-to-sales ratio was", options: ["Q1", "Q2", "Q3", "Q4"], answer: "Q2" },
      { text: "and the quarter with the highest total sales was", options: ["Q1", "Q2", "Q3", "Q4"], answer: "Q3" }
    ]
  },
  {
    id: 260,
    section: "Data Insights",
    type: "graphicsInterpretation",
    topic: "Graphics Interpretation",
    difficultyLevel: "Hard",
    difficultyScore: 725,
    discrimination: 1.5,
    timeLimit: 195,
    image: null,
    chart: {"type":"line","title":"Monthly Closing Stock Price ($)","labels":["Jan","Feb","Mar","Apr","May","Jun"],"series":[{"name":"Price","values":[45,50,43,48,55,52]}],"unit":"$","yLabel":"Price ($)"},
    blanks: [
      { text: "The month with the highest stock price was", options: ["Feb", "Apr", "May", "Jun"], answer: "May" },
      { text: "and the approximate percentage change in price from Feb to Mar was", options: ["-14%", "-5%", "+9%", "+14%"], answer: "-14%" }
    ]
  },
  {
    id: 261,
    section: "Data Insights",
    type: "graphicsInterpretation",
    topic: "Graphics Interpretation",
    difficultyLevel: "Hard",
    difficultyScore: 750,
    discrimination: 1.56,
    timeLimit: 200,
    image: null,
    chart: {"type":"line","title":"Monthly Customer Churn Rate (%)","labels":["Jan","Feb","Mar","Apr","May","Jun"],"series":[{"name":"Churn","values":[5,5.5,6,5.6,5.2,4.8]}],"unit":"%","yLabel":"Churn rate"},
    blanks: [
      { text: "The month with the highest churn rate was", options: ["Jan", "Feb", "Mar", "Jun"], answer: "Mar" },
      { text: "and the approximate change in churn rate from Jan to Mar was", options: ["-20%", "+10%", "+20%", "+40%"], answer: "+20%" }
    ]
  },


  // 5. TWO-PART ANALYSIS

  // ── Hard ──
  {
    id: 205,
    section: "Data Insights",
    type: "twoPartAnalysis",
    topic: "Two-Part Analysis",
    difficultyLevel: "Hard",
    difficultyScore: 680,
    discrimination: 1.3,
    timeLimit: 180,
    question: "Two investments together earn ₹9,000 in interest. Investment A earns interest at 5% and has a principal of ₹40,000. Investment B earns interest at 7%. Select the interest Amount earned by Investment B, and the Rate at which Investment A earned interest.",
    image: null,
    columns: ["Amount (Investment B)", "Rate (Investment A)"],
    options: ["5%", "7%", "₹2,000", "₹7,000"],
    answers: { "Amount (Investment B)": "₹7,000", "Rate (Investment A)": "5%" }
  },

  // ── Easy ──
  {
    id: 262,
    section: "Data Insights",
    type: "twoPartAnalysis",
    topic: "Two-Part Analysis",
    difficultyLevel: "Easy",
    difficultyScore: 405,
    discrimination: 0.86,
    timeLimit: 140,
    question: "A rectangle has a perimeter of 28 cm and a length of 8 cm. Select the Width of the rectangle, and the Area of the rectangle.",
    image: null,
    columns: ["Width", "Area"],
    options: ["6 cm", "8 cm", "48 cm²", "56 cm²"],
    answers: { "Width": "6 cm", "Area": "48 cm²" }
  },
  {
    id: 263,
    section: "Data Insights",
    type: "twoPartAnalysis",
    topic: "Two-Part Analysis",
    difficultyLevel: "Easy",
    difficultyScore: 428,
    discrimination: 0.87,
    timeLimit: 142,
    question: "Two numbers have a sum of 20 and a difference of 4. Select the Larger number, and the Smaller number.",
    image: null,
    columns: ["Larger number", "Smaller number"],
    options: ["8", "10", "12", "14"],
    answers: { "Larger number": "12", "Smaller number": "8" }
  },
  {
    id: 264,
    section: "Data Insights",
    type: "twoPartAnalysis",
    topic: "Two-Part Analysis",
    difficultyLevel: "Easy",
    difficultyScore: 448,
    discrimination: 0.89,
    timeLimit: 145,
    question: "A shop sells pens at ₹15 each and pencils at ₹5 each. A customer buys some pens and 2 pencils, spending ₹70 in total. Select the number of Pens purchased, and the total Cost of Pencils.",
    image: null,
    columns: ["Number of Pens", "Cost of Pencils"],
    options: ["4", "5", "₹10", "₹15"],
    answers: { "Number of Pens": "4", "Cost of Pencils": "₹10" }
  },
  {
    id: 265,
    section: "Data Insights",
    type: "twoPartAnalysis",
    topic: "Two-Part Analysis",
    difficultyLevel: "Easy",
    difficultyScore: 468,
    discrimination: 0.9,
    timeLimit: 148,
    question: "A car travels at a constant speed and covers 180 km in 3 hours. Select the Speed of the car, and the Distance it would cover in 5 hours at the same speed.",
    image: null,
    columns: ["Speed", "Distance in 5 hours"],
    options: ["60 km/h", "90 km/h", "300 km", "450 km"],
    answers: { "Speed": "60 km/h", "Distance in 5 hours": "300 km" }
  },
  {
    id: 266,
    section: "Data Insights",
    type: "twoPartAnalysis",
    topic: "Two-Part Analysis",
    difficultyLevel: "Easy",
    difficultyScore: 488,
    discrimination: 0.92,
    timeLimit: 150,
    question: "A number increased by 8 equals 20. Select the value of the Number, and the value of the Number multiplied by 3.",
    image: null,
    columns: ["The Number", "The Number × 3"],
    options: ["12", "14", "36", "42"],
    answers: { "The Number": "12", "The Number × 3": "36" }
  },

  // ── Medium ──
  {
    id: 267,
    section: "Data Insights",
    type: "twoPartAnalysis",
    topic: "Two-Part Analysis",
    difficultyLevel: "Medium",
    difficultyScore: 512,
    discrimination: 1.12,
    timeLimit: 165,
    question: "A shopkeeper sells an item at a 25% profit. If the cost price is ₹800, select the Profit Amount, and the Selling Price.",
    image: null,
    columns: ["Profit Amount", "Selling Price"],
    options: ["₹150", "₹200", "₹950", "₹1,000"],
    answers: { "Profit Amount": "₹200", "Selling Price": "₹1,000" }
  },
  {
    id: 268,
    section: "Data Insights",
    type: "twoPartAnalysis",
    topic: "Two-Part Analysis",
    difficultyLevel: "Medium",
    difficultyScore: 550,
    discrimination: 1.15,
    timeLimit: 168,
    question: "The sum of three consecutive integers is 72. Select the Smallest integer, and the Largest integer.",
    image: null,
    columns: ["Smallest integer", "Largest integer"],
    options: ["22", "23", "25", "26"],
    answers: { "Smallest integer": "23", "Largest integer": "25" }
  },
  {
    id: 269,
    section: "Data Insights",
    type: "twoPartAnalysis",
    topic: "Two-Part Analysis",
    difficultyLevel: "Medium",
    difficultyScore: 585,
    discrimination: 1.18,
    timeLimit: 170,
    question: "A sum of ₹5,000 is invested at simple interest for 2 years, earning ₹600 in interest. Select the Rate of interest per annum, and the total Amount after 2 years.",
    image: null,
    columns: ["Rate of Interest", "Total Amount after 2 Years"],
    options: ["5%", "6%", "₹5,600", "₹6,000"],
    answers: { "Rate of Interest": "6%", "Total Amount after 2 Years": "₹5,600" }
  },
  {
    id: 270,
    section: "Data Insights",
    type: "twoPartAnalysis",
    topic: "Two-Part Analysis",
    difficultyLevel: "Medium",
    difficultyScore: 618,
    discrimination: 1.2,
    timeLimit: 175,
    question: "Pipes A and B can each fill a tank alone in 10 hours and 15 hours respectively. Select the time taken to fill the tank if both work together (in hours), and the fraction of the tank filled by Pipe A alone in 3 hours.",
    image: null,
    columns: ["Time working together (hours)", "Fraction filled by Pipe A in 3 hours"],
    options: ["6", "10", "3/10", "1/5"],
    answers: { "Time working together (hours)": "6", "Fraction filled by Pipe A in 3 hours": "3/10" }
  },

  // ── Hard ──
  {
    id: 271,
    section: "Data Insights",
    type: "twoPartAnalysis",
    topic: "Two-Part Analysis",
    difficultyLevel: "Hard",
    difficultyScore: 635,
    discrimination: 1.4,
    timeLimit: 190,
    question: "A sum of ₹12,000 is divided between two investments. Investment X earns 8% annual interest and Investment Y earns 10% annual interest. The total interest earned in one year is ₹1,080. Select the Amount invested in Investment X, and the Amount invested in Investment Y.",
    image: null,
    columns: ["Amount in Investment X", "Amount in Investment Y"],
    options: ["₹4,000", "₹6,000", "₹8,000", "₹9,000"],
    answers: { "Amount in Investment X": "₹6,000", "Amount in Investment Y": "₹6,000" }
  },
  {
    id: 272,
    section: "Data Insights",
    type: "twoPartAnalysis",
    topic: "Two-Part Analysis",
    difficultyLevel: "Hard",
    difficultyScore: 665,
    discrimination: 1.43,
    timeLimit: 195,
    question: "A mixture of milk and water weighs 40 kg, with milk and water in the ratio 3:1. If 5 kg of water is added to the mixture, select the new percentage of milk in the mixture, and the new total weight of the mixture.",
    image: null,
    columns: ["New percentage of milk", "New total weight"],
    options: ["60%", "66.7%", "40 kg", "45 kg"],
    answers: { "New percentage of milk": "66.7%", "New total weight": "45 kg" }
  },
  {
    id: 273,
    section: "Data Insights",
    type: "twoPartAnalysis",
    topic: "Two-Part Analysis",
    difficultyLevel: "Hard",
    difficultyScore: 700,
    discrimination: 1.47,
    timeLimit: 200,
    question: "Train A leaves a station traveling at 60 km/h. Two hours later, Train B leaves the same station on the same route traveling at 90 km/h. Select the time after Train B's departure at which it catches up to Train A, and the distance from the station at which this occurs.",
    image: null,
    columns: ["Time after Train B's departure", "Distance from the station"],
    options: ["2 hours", "4 hours", "240 km", "360 km"],
    answers: { "Time after Train B's departure": "4 hours", "Distance from the station": "360 km" }
  },
  {
    id: 274,
    section: "Data Insights",
    type: "twoPartAnalysis",
    topic: "Two-Part Analysis",
    difficultyLevel: "Hard",
    difficultyScore: 725,
    discrimination: 1.5,
    timeLimit: 205,
    question: "A company's profit grew from ₹8 lakh in Year 1 to ₹12.5 lakh in Year 3, growing at the same percentage rate each year. Select the approximate annual percentage growth rate, and the profit in Year 2.",
    image: null,
    columns: ["Annual percentage growth rate", "Profit in Year 2"],
    options: ["20%", "25%", "₹9.5 lakh", "₹10 lakh"],
    answers: { "Annual percentage growth rate": "25%", "Profit in Year 2": "₹10 lakh" }
  },
  {
    id: 275,
    section: "Data Insights",
    type: "twoPartAnalysis",
    topic: "Two-Part Analysis",
    difficultyLevel: "Medium",
    difficultyScore: 605,
    discrimination: 1.2,
    timeLimit: 175,
    question: "A recipe requires flour and sugar in the ratio 5:2 by weight, currently totaling 3.5 kg. The cook wants to scale the recipe so the total weight becomes 7 kg while keeping the same ratio. Select the new weight of flour, and the new weight of sugar.",
    image: null,
    columns: ["New weight of flour", "New weight of sugar"],
    options: ["2 kg", "2.5 kg", "5 kg", "5.5 kg"],
    answers: { "New weight of flour": "5 kg", "New weight of sugar": "2 kg" }
  }

];

export default gmatDataInsights;